import { render, staticRenderFns } from "./TravelTimeReportTable.vue?vue&type=template&id=45dd2e54"
import script from "./TravelTimeReportTable.vue?vue&type=script&lang=js"
export * from "./TravelTimeReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports